import type { VmCreateInputs } from "@/modules/compute/vmCreateViewModel.tsx";
import { Trans } from "@lingui/react/macro";
import { useFormContext } from "react-hook-form";

export function VmRootUserWarning() {
    //#region Hooks
    const { watch } = useFormContext<VmCreateInputs>();

    return (
        watch("username") === "root" && (
            <p className="color-warning font-size-small pt-1">
                <Trans>
                    SSH might not be available for root user due to operating system initial setup. Please use virtual
                    console to access the system and make the SSH server config changes according to your needs.
                </Trans>
            </p>
        )
    );
}
